






























import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import * as images from "../../assets/images";
//@ts-ignore
import * as pdfMake from "pdfmake/build/pdfmake";
//@ts-ignore
import * as pdfFonts from "pdfmake/build/vfs_fonts";
import { bus } from "@/main";
import * as user from "@/_store/user.module";
import { close } from "fs";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
@Component
export default class DocDVRReview extends Vue {
    @Prop() docInfo!: any;
    @Prop() emailAzienda!: string;
    private userInfo: any ;

    constructor() {
        super();
        this.userInfo = {};
    }

    @Watch("docInfo", { immediate: true, deep: true })
    onDocInfoChange(newVal: any, oldVal: any) {
        if (newVal && newVal.idDocDVR && newVal.allegato) {
            this.$nextTick(() => {
                this.createDoc();
            });
        }
    }

    confirm() {
        if (this.docInfo && this.docInfo.idDocDVR) {
            user.dispatchConfirmDocDVR(this["$store"], this.docInfo.idDocDVR)
                .then(() => {
                    this.close();
                    bus.$emit("loadPreAssegnazioni");
                    bus.$emit(
                        "successfullOperation",
                        "Documento DVR confermato con successo"
                    );
                })
                .catch(error => {
                    if (error.response.status === 403) {
                        bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                        this["$router"].push("/login");
                    } else {
                        bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                    }
                });
        } else {
            bus.$emit(
                "errorOperation",
                "Impossibile accettare documento. Documento DVR mancante"
            );
        }
    }

    close() {
        bus.$emit("closeReview");
    }

    refuse() {
        if (this.docInfo && this.docInfo.idDocDVR) {
            user.dispatchRefuseDocDVR(this["$store"], this.docInfo.idDocDVR)
                .then(() => {
                    user.dispatchRefuseDoc(this["$store"], { docType: 'docDVR', email: this.emailAzienda })
                    .then(() => {

                    })
                    .catch(error => {
                        if (error.response.status === 403) {
                            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                            this["$router"].push("/login");
                        } else {
                            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                        }
                    });

                    this.close();
                    bus.$emit("loadPreAssegnazioni");
                    bus.$emit(
                        "successfullOperation",
                        "Documento DVR rifiutato con successo"
                    );
                })
                .catch(error => {
                    if (error.response.status === 403) {
                        bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                        this["$router"].push("/login");
                    } else {
                        bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                    }
                });
        } else {
            bus.$emit(
                "errorOperation",
                "Impossibile rifiutare documento. Documento DVR mancante"
            );
        }
    }

    createDoc() {
        if (!this.docInfo || !this.docInfo.allegato) {
            return;
        }

        try {
            const byteCharacters = atob(this.docInfo.allegato);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: "application/pdf" });
            const blobUrl = URL.createObjectURL(blob);

            const iframe = document.createElement("iframe");
            iframe.src = blobUrl;
            iframe.width = "100%";
            iframe.height = "600px";
            iframe.style.border = "none";

            const container = document.getElementById("iframeContainer");
            if (container) {
                container.innerHTML = "";
                container.appendChild(iframe);
            } else {
                console.error("Container iframeContainer non trovato");
            }
        } catch (error) {
            console.error("Errore durante la creazione del PDF:", error);
        }
    }

    created() {
        var userInfo: any = user.readUserInfo(this["$store"]);
        this.userInfo = userInfo;
    }
}
